module.exports = __webpack_public_path__ + "img/img_dzp.9c8556fd.png";